<script>
  export default {
    name: 'Header'
  }
</script>

<template lang="pug">
  .header
    h1.header__title
      img(
        src = '~@/assets/img/logo_deco.png'
        )
    p.header__description
      |質問に答えて、住友生命
      br.brNoto
      |「Vitality」をもっと楽しもう！
    p.header__date
      |開催期間： 2/3～3/16
</template>

<style lang="scss">
  .header {
    display: flex;
    flex-direction: column;
    align-items: center;
    @include l-more-than-mobile {
      margin-bottom: 25px;
    }
    &__title {
      @include l-more-than-mobile {
        margin-bottom: 3px;
      }
      @include l-mobile {
        margin-bottom: -10px;
      }
      img {
        @include l-more-than-mobile {
          width: 400px;
          height: 158px;
        }
        @include l-mobile {
          width: 271px;
          height: 108px;
        }
      }
    }
    &__description {
      line-height: (32 / 24);
      color: $primary-color;
      @include fontSizeAll(24, 12);
      text-align: center;
      @include l-more-than-mobile {
        margin-bottom: 15px;
      }
      @include l-mobile {
        margin-bottom: 6px;
      }
    }
    &__date {
      box-sizing: border-box;
      line-height: 1;
      color: $base-color;
      @include fontSizeAll(14, 12);
      background-color: $primary-color;
      @include l-more-than-mobile {
        height: 29px;
        padding-top: 6px;
        padding-right: 15px;
        padding-left: 15px;
        border-radius: 14.5px;
      }
      @include l-mobile {
        height: 21px;
        padding-top: 5px;
        padding-right: 10px;
        padding-left: 10px;
        border-radius: 10.5px;
      }
    }
  }
</style>
